import React, { useState, useEffect, useMemo } from "react";

import RegisterSettingFormLogic from "./RegisterSettingFormLogic";
import TextField from "@mui/material/TextField";
import CustomHeader from "../../../reuseableComponents/CustomHeader";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { Grid } from "@mui/material";
import BasicTextFields from "../../../reuseableComponents/TextInputField";
import SelectDropDown from "../../../reuseableComponents/SelectDropDown";
import axios from "axios";
import { BASE_URL, CHECK_END_DAY } from "../../../Constants/Config";
import { useSelector } from "react-redux";
import AlertModal from "../../../reuseableComponents/AlertModal";
import { Box, Modal } from "@mui/material";
import CrossIcon from "../../../Assests/Dashboard/cross.svg";
import { useDispatch } from "react-redux";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { addActualAmountData } from "../../../Redux/features/SystemAccess/systemAccessSlice";
import PasswordShow from "../../../Common/passwordShow";
import HoverInfoLogo from "../../../reuseableComponents/HoverInfoLogo";

const MainResigtersetting = () => {
  // const [alertmsg, setAlertMsg] = useState('');
  const { userTypeData, LoginGetDashBoardRecordJson } = useAuthDetails();
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const AllInSystemAccessState = useSelector((state) => state.RegisterSettingsData);
  const [openAlert, setOpenAlert] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader1, setLoader1] = useState(false);
  const dispatch = useDispatch();

  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  // const {
  //   handleRegisterSettingInput,
  //   values,
  //   handleRegisterSettingSubmit,
  //   submitmessage,
  //   // showModal,
  //   // setShowModal,
  //   // scrollRef,,
  //   setsubmitmessage,
  //   loader,
  // } = RegisterSettingFormLogic();

  const DayAllow = [
    {
      title: "Deny if staff clocked in",
    },
    {
      title: "Mass clock out staff clocked in",
    },
    {
      title: "Ignore Time Clock",
    },
  ];
  const SiftAssign = [
    {
      title: "Don’t Track Shifts",
    },
    {
      title: "Track Shifts by Cashier",
    },
    {
      title: "Track Shifts by Station",
    },
  ];

  const openModal = () => {
    setShowModal(true);
  };
  const goToTop = () => {
    setsubmitmessage();
  };
  const closeModal = () => {
    setActualAmount((preValue) => {
      return {
        ...preValue,
        actual_amt: "",
      };
    });
    setShowModal(false);
  };

  const handleClose = () => setShowModal(false);
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [alertModalHeaderText, setAlertModalHeaderText] = useState("");
  const [systemAccess, setallSystemAccess] = useState({
    default_cash_drawer: "",
    clock_in: false,
    hide_inactive: false,
    end_day_Allow: "",
    shift_assign: "",
    // start_date: "",
    // end_date: "",
    start_time: "",
    end_time: "",
    emp_permission: "",
    no_of_station: "",
    report_history: "",
  });
  // =================
  const {
    handleRegisterSettingInput,
    values,
    handleRegisterSettingSubmit,
    submitmessage,
    // showModal,
    // setShowModal,
    // scrollRef,,
    setsubmitmessage,
    loader,
  } = RegisterSettingFormLogic({ systemAccess });
  // ===============
  const [selectedDayAllow, setSelectedDayAllow] = useState("");
  const [selectShiftAssign, setSelectShiftAssign] = useState("");
  const [selectedStartDay, setSelectedStartDay] = useState("");
  const [selectedEndDay, setSelectedEndDay] = useState("");
  const [actualAmount, setActualAmount] = useState({
    actual_amt: "",
  });
  const myStyles = {
    width: "60%",
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontFamily: "'CircularSTDMedium', sans-serif !important",
  };

  const handleCashDrawerChange = (e) => {
    const { name, value, selectionStart } = e.target;

    let fieldValue;
    fieldValue = value
      // Remove extra dots and ensure only one dot exists at most
      .replace(/[^\d.]/g, "") // Allow digits and dots only
      .replace(/^(\d*\.)(.*)\./, "$1$2") // Remove extra dots
      .replace(/^(\d*\.\d*)(.*)\./, "$1$2"); // Remove extra dots after the decimal point

    let inputStr = fieldValue.replace(/\D/g, "");
    inputStr = inputStr.replace(/^0+/, "");

    if (inputStr.length == "") {
      fieldValue = "0.00";
    } else if (inputStr.length === 1) {
      fieldValue = "0.0" + inputStr;
    } else if (inputStr.length === 2) {
      fieldValue = "0." + inputStr;
    } else {
      fieldValue =
        inputStr.slice(0, inputStr.length - 2) + "." + inputStr.slice(-2);
    }
    const cursorAdjustment = fieldValue.length;
    if (name === "default_cash_drawer" && fieldValue.length > 1) {
      requestAnimationFrame(() => {
        e.target.setSelectionRange(
          selectionStart + cursorAdjustment,
          selectionStart + cursorAdjustment
        );
      });
    }
    setallSystemAccess((prevState) => ({
      ...prevState,
      [name]: fieldValue,
    }));
    // console.log("name and value", name, value);
  };

  const handleActualAmtInputChange = (e) => {
    const { name, value } = e.target;
    let fieldValue;
    fieldValue = value
      // Remove extra dots and ensure only one dot exists at most
      .replace(/[^\d.]/g, "") // Allow digits and dots only
      .replace(/^(\d*\.)(.*)\./, "$1$2") // Remove extra dots
      .replace(/^(\d*\.\d*)(.*)\./, "$1$2"); // Remove extra dots after the decimal point
    let inputStr = fieldValue.replace(/\D/g, "");
    inputStr = inputStr.replace(/^0+/, "");

    if (inputStr.length == "") {
      fieldValue = "0.00";
    } else if (inputStr.length === 1) {
      fieldValue = "0.0" + inputStr;
    } else if (inputStr.length === 2) {
      fieldValue = "0." + inputStr;
    } else {
      fieldValue =
        inputStr.slice(0, inputStr.length - 2) + "." + inputStr.slice(-2);
    }
    setActualAmount((preValue) => {
      return {
        ...preValue,
        [name]: fieldValue,
      };
    });
  };
  const handleKeyPress = (e) => {
    if ((e.charCode < 48 || e.charCode > 57) && e.charCode !== 8) {
      e.preventDefault();
    }
  };
  const checkEndofDay = async () => {
    const checkdata = { merchant_id, ...userTypeData };
    try {
      const res = await axios.post(BASE_URL + CHECK_END_DAY, checkdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData.token}`, // Use data?.token directly
        },
      });
      return res.data;
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const loginType = "login_via_superadmin";
  const showEODButton = useMemo(() => {
    const bool =
      Number(systemAccess?.shift_assign) == 3 &&
      Number(AllInSystemAccessState?.RegisterSettingsData?.shift_assign) == 3 &&
      loginType == "login_via_superadmin";

    return bool;
  }, [
    systemAccess?.shift_assign,
    AllInSystemAccessState?.RegisterSettingsData?.shift_assign,
    loginType,
  ]);

  const handleActualAmtSave = async (e) => {
    try {
      setLoader1(true);
      const data = {
        merchant_id,
        actual_amt: actualAmount.actual_amt,
        ...userTypeData,
      };
      const res = await dispatch(addActualAmountData(data));
      ToastifyAlert(res.payload.msg, res.payload.status ? "success" : "error");
      // if (res.payload.status) {
      //   ToastifyAlert(res.payload.msg, "success");
      // } else {
      //   ToastifyAlert(res.payload.msg, "error");
      // }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    } finally {
      setLoader1(false);
      closeModal();
    }
  };

  useEffect(() => {
    if (
      !AllInSystemAccessState.loading &&
      AllInSystemAccessState.RegisterSettingsData
    ) {
      const updatedData = {
        ...AllInSystemAccessState.RegisterSettingsData,
        clock_in:
          AllInSystemAccessState.RegisterSettingsData.clock_in === "1"
            ? true
            : false,
        hide_inactive:
          AllInSystemAccessState.RegisterSettingsData.hide_inactive === "1"
            ? true
            : false,
      };
      setallSystemAccess(updatedData);
    }
  }, [
    AllInSystemAccessState,
    AllInSystemAccessState.loading,
    AllInSystemAccessState.systemAccessData,
  ]);

  const handleOptionClick = (option, dropdown) => {
    switch (dropdown) {
      case "StartDay":
        setSelectedStartDay(option.title);
        // Set defaults.type based on the selected option
        let StartDay;
        switch (option.title) {
          case "Yesterday":
            StartDay = 1; // You can set it to an empty string or another default value
            break;
          case "Today":
            StartDay = 2;
            break;
          // Add more cases if needed
          default:
            StartDay = ""; // Set a default value if necessary
            break;
        }
        setallSystemAccess((prevValue) => ({
          ...prevValue,
          start_date: StartDay,
        }));
        break;
      case "EndDay":
        setSelectedEndDay(option.title);
        // Set defaults.type based on the selected option
        let EndDay;
        switch (option.title) {
          case "Today":
            EndDay = 1; // You can set it to an empty string or another default value
            break;
          case "Tomorrow":
            EndDay = 2;
            break;
          // Add more cases if needed
          default:
            EndDay = ""; // Set a default value if necessary
            break;
        }
        setallSystemAccess((prevValue) => ({
          ...prevValue,
          end_date: EndDay,
        }));
        break;
      case "DayAllow":
        setSelectedDayAllow(option.title);
        // Set defaults.type based on the selected option
        let DayAllow;
        switch (option.title) {
          case "Deny if staff clocked in":
            DayAllow = 1; // You can set it to an empty string or another default value
            break;
          case "Mass clock out staff clocked in":
            DayAllow = 2;
            break;
          // Add more cases if needed
          case "Ignore Time Clock":
            DayAllow = 3;
            break;
          default:
            DayAllow = ""; // Set a default value if necessary
            break;
        }
        setallSystemAccess((prevValue) => ({
          ...prevValue,
          end_day_Allow: DayAllow,
        }));
        break;
      case "SiftAssign":
        checkEndofDay().then((res) => {
          if (
            res.status === false &&
            res.msg === "You not can change setting, perform End of Day first"
          ) {
            setAlertModalHeaderText(
              "First perform end of day to make changes here."
            );
            setAlertModalOpen(true);
            return;
          } else {
            setAlertModalHeaderText("");
            setAlertModalOpen(false);
            setSelectShiftAssign(option.title);
            let siftAssValue;
            switch (option.title) {
              case "Don’t Track Shifts":
                siftAssValue = 1;
                break;
              case "Track Shifts by Cashier":
                siftAssValue = 2;
                break;
              case "Track Shifts by Station":
                siftAssValue = 3;
                break;
              default:
                siftAssValue = "";
                break;
            }
            setallSystemAccess((prevValue) => ({
              ...prevValue,
              shift_assign: siftAssValue,
            }));
          }
        });
        break;
      default:
        break;
    }
  };

  const defaultSiftAssign = (day) => {
    if (day == 1) {
      return "Don’t Track Shifts";
    } else if (day == 2) {
      return "Track Shifts by Cashier";
    } else if (day == 3) {
      return "Track Shifts by Station";
    }
  };
  const defaultEndDayAllowance = (day) => {
    if (day == 1) {
      return "Deny if staff clocked in";
    } else if (day == 2) {
      return "Mass clock out staff clocked in";
    } else if (day == 3) {
      return "Ignore Time Clock";
    }
  };

  useEffect(() => {
    // setSelectedStartDay(startDay(systemAccess.start_date));
    // setSelectedEndDay(endDay(systemAccess.end_date));
    // setSelectedDayAllow(DayAll(systemAccess.end_day_Allow)); Mass clock out staff clocked in   Ignore Time Clock setSelectedDayAllow("Deny if staff clocked in");
    setSelectShiftAssign(defaultSiftAssign(systemAccess.shift_assign));
    setSelectedDayAllow(defaultEndDayAllowance(systemAccess?.end_day_Allow));
  }, [systemAccess]);

  return (
    <>
      {/* resigter method */}
      <Grid sx={{ mb: 14 }} className="box qv-register-prefs">
        <div className="q-attributes-main-page">
          <div className="q-resigtersetting-top-detail-section">
            <div className="">
              <CustomHeader>Register Preferences</CustomHeader>
              <div className="q-resigtersetting-bottom-section">
                <div className="q_resigter_checkboxfiled flex-wrap mt-8 px-2 sm:px-6">
                  <ul className="custom-checkbox-list flex space-x-5">
                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("1")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Stock Prompt
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="1"
                        checked={values.regi_setting.split(",").includes("1")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>

                    {/* <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("2")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Combine Lines
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="2"
                        checked={values.regi_setting.split(",").includes("2")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label> */}

                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("3")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Customer Last Price Prompt
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="3"
                        checked={values.regi_setting.split(",").includes("3")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>

                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("4")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Prompt Customer Info on PinPad
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="4"
                        checked={values.regi_setting.split(",").includes("4")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>

                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.denomination ? "text-black" : ""
                        } `}
                      >
                        Denomination
                      </p>
                      <input
                        type="checkbox"
                        name="denomination"
                        checked={values.denomination}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>
                    {userTypeData?.login_type?.toString()?.toLowerCase() ==
                    "superadmin" ? (
                      <label className="q_resigter_setting_section">
                        <p
                          className={`${
                            values.upload_paxlog ? "text-black" : ""
                          } `}
                        >
                          Upload Paxlog
                        </p>
                        <input
                          type="checkbox"
                          name="upload_paxlog"
                          checked={values.upload_paxlog}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="checkmark"></span>
                      </label>
                    ) : (
                      ""
                    )}

                    <label className="q_resigter_setting_section">
                      <p className={`${values.shared_lp ? "text-black" : ""} `}>
                        Enable LP sharing with other locations
                      </p>
                      <input
                        type="checkbox"
                        name="shared_lp"
                        checked={values.shared_lp}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("8")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Disable Tax Prompt for Custom Items
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="8"
                        checked={values.regi_setting.split(",").includes("8")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("12")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        NumPad Payout
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="12"
                        checked={values.regi_setting.split(",").includes("12")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("11")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Custom Item Check ID
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="11"
                        checked={values.regi_setting.split(",").includes("11")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label className="q_resigter_setting_section">
                      <p
                        className={`${
                          values.regi_setting.split(",").includes("10")
                            ? "text-black"
                            : ""
                        } `}
                      >
                        Allow custom item as EBT
                      </p>
                      <input
                        type="checkbox"
                        name="regi_setting[]"
                        value="10"
                        checked={values.regi_setting.split(",").includes("10")}
                        onChange={handleRegisterSettingInput}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </ul>
                </div>
                <div className="q-resigtersetting-bottom-section mt-8 px-2 sm:px-6">
                  <div className="heading">Payment Method</div>

                  <div className="q_resigter_checkboxfiled mt-8">
                    <ul className="custom-checkbox-list flex space-x-5">
                      <label className="q_resigter_setting_section">
                        <p
                          className={`${
                            values.ebt_type.split(",").includes("1")
                              ? "text-black"
                              : ""
                          } `}
                        >
                          Food EBT
                        </p>
                        {/* <input type="checkbox" checked="checked" />  */}
                        <input
                          type="checkbox"
                          name="ebt_type[]"
                          value="1"
                          checked={values.ebt_type.split(",").includes("1")}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="checkmark"></span>
                      </label>

                      <label className="q_resigter_setting_section">
                        <p
                          className={`${
                            values.ebt_type.split(",").includes("2")
                              ? "text-black"
                              : ""
                          } `}
                        >
                          Cash EBT
                        </p>
                        <input
                          type="checkbox"
                          name="ebt_type[]"
                          value="2"
                          checked={values.ebt_type.split(",").includes("2")}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="checkmark"></span>
                      </label>

                      <label className="q_resigter_setting_section">
                        <p
                          className={`${
                            values.ebt_type.split(",").includes("3")
                              ? "text-black"
                              : ""
                          } `}
                        >
                          Gift Card
                        </p>
                        <input
                          type="checkbox"
                          name="ebt_type[]"
                          value="3"
                          checked={values.ebt_type.split(",").includes("3")}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="checkmark"></span>
                      </label>

                      <label className="q_resigter_setting_section">
                        <p
                          className={`${
                            values.ebt_type.split(",").includes("4")
                              ? "text-black"
                              : ""
                          } `}
                        >
                          Lottery Payout
                        </p>
                        <input
                          type="checkbox"
                          name="ebt_type[]"
                          value="4"
                          checked={values.ebt_type.split(",").includes("4")}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="checkmark"></span>
                      </label>

                      {/* QV-7233 — slot 5 of the same `ebt` CSV, but the sense
                          is inverted: checked ⇒ debit tile OFF on the register. */}
                      <label className="q_resigter_setting_section">
                        <p
                          className={`${
                            values.ebt_type.split(",").includes("5")
                              ? "text-black"
                              : ""
                          } `}
                        >
                          Hide Debit Card
                        </p>
                        <input
                          type="checkbox"
                          name="ebt_type[]"
                          value="5"
                          checked={values.ebt_type.split(",").includes("5")}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </ul>
                  </div>
                </div>
                <div className="q-resigtersetting-bottom-section mt-8 px-2 sm:px-6">
                  <div className="heading">Quick Add</div>

                  <div className="text-sm text-[#545454] CircularSTDBook">
                    Quick Add If bar code scanned is not found
                  </div>
                  <div className="q_resigter flex-wrap mt-5">
                    <ul className="custom-checkbox-list flex flex-wrap gap-2">
                      <label className="q_setting_radio_resigter">
                        <p
                          className={`${
                            values.barcode_msg === "1" ? "text-black" : ""
                          } `}
                        >
                          Display ‘Item not Found’
                        </p>
                        <input
                          type="radio"
                          name="barcode_msg"
                          value="1"
                          onChange={handleRegisterSettingInput}
                          checked={values.barcode_msg === "1"}
                        />
                        <span className="checkmark_section"></span>
                      </label>

                      <label className="q_setting_radio_resigter">
                        <p
                          className={`${
                            values.barcode_msg === "2" ? "text-black" : ""
                          } `}
                        >
                          Quick Enter, Forced
                        </p>
                        <input
                          type="radio"
                          name="barcode_msg"
                          value="2"
                          onChange={handleRegisterSettingInput}
                          checked={values.barcode_msg === "2"}
                        />
                        <span className="checkmark_section"></span>
                      </label>
                      <label className="q_setting_radio_resigter">
                        <p
                          className={`${
                            values.barcode_msg === "3" ? "text-black" : ""
                          } `}
                        >
                          Quick Enter, Prompt
                        </p>
                        <input
                          type="radio"
                          name="barcode_msg"
                          value="3"
                          onChange={handleRegisterSettingInput}
                          checked={values.barcode_msg === "3"}
                        />
                        <span className="checkmark_section"></span>
                      </label>
                      <label className="q_setting_radio_resigter">
                        <p
                          className={`${
                            values.barcode_msg === "4" ? "text-black" : ""
                          } `}
                        >
                          Full Enter, Forced
                        </p>
                        <input
                          type="radio"
                          name="barcode_msg"
                          value="4"
                          onChange={handleRegisterSettingInput}
                          checked={values.barcode_msg === "4"}
                        />
                        <span className="checkmark_section"></span>
                      </label>
                      <label className="q_setting_radio_resigter">
                        <p
                          className={`${
                            values.barcode_msg === "5" ? "text-black" : ""
                          } `}
                        >
                          Full Enter, Prompt
                        </p>
                        <input
                          type="radio"
                          name="barcode_msg"
                          value="5"
                          onChange={handleRegisterSettingInput}
                          checked={values.barcode_msg === "5"}
                        />
                        <span className="checkmark_section"></span>
                      </label>
                    </ul>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8 px-2 sm:px-6">
                  <div className="col-span-1 sm:col-span-2 md:col-span-2">
                    <label className="text-[#6A6A6A] " htmlFor="idlelogout">
                      Idle Logout Minutes
                    </label>
                    <div className="w-full mt-2">
                      {/* <Input
                        className="q_input_resigter"
                        name="idel_logout"
                        onChange={handleRegisterSettingInput}
                        value={values.idel_logout}
                        placeholder="Enter idle logout"
                      /> */}

                      <TextField
                        sx={{
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--qv-bd-000000, black)",
                            },
                          },
                        }}
                        id="outlined-basic"
                        type="text"
                        name="idel_logout"
                        placeholder="Enter idle logout"
                        onChange={handleRegisterSettingInput}
                        value={values.idel_logout}
                        variant="outlined"
                        size="small"
                      />
                    </div>
                    <span className="input-error">
                      {values.errors.idel_logout !== ""
                        ? values.errors.idel_logout
                        : ""}
                    </span>
                  </div>
                </div>

                <Grid
                  container
                  spacing={4}
                  sx={{ px: { xs: 1, sm: 2.5 } }}
                  alignItems="flex-end"
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <label className="text-[#6A6A6A] " htmlFor="idlelogout">
                      Default Cash Drawer Start
                    </label>
                    <BasicTextFields
                      type="text"
                      inputMode="numeric"
                      name="default_cash_drawer"
                      onChangeFun={handleCashDrawerChange}
                      value={systemAccess.default_cash_drawer || ""}
                      maxLength={8}
                      placeholder={"0.00"}
                      onKeyPressFun={handleKeyPress}
                      sx={{ pt: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <div className="qv_checkbox" style={{ paddingBottom: 6 }}>
                      <label className="qv_checkbox_add_checkmark_label">
                        <span
                          className={`${
                            values.enable_cash_drop_and_closing_amount
                              ? "text-black"
                              : ""
                          }`}
                          style={{ display: "inline", lineHeight: "22px" }}
                        >
                          Enable Cash Drop And Closing Amount
                          {/* Inline (not flex-wrap) so the text wraps as a
                              sentence and the icon trails the last word. */}
                          <span
                            style={{
                              display: "inline-flex",
                              verticalAlign: "middle",
                              marginLeft: 4,
                            }}
                          >
                            <HoverInfoLogo
                              title="When enabled, a pop-up will appear during shift close to enter the cash drop amount and calculate the remaining closing amount."
                              placement="top"
                              maxWidth={320}
                            />
                          </span>
                        </span>
                        <input
                          type="checkbox"
                          name="enable_cash_drop_and_closing_amount"
                          checked={Boolean(
                            values.enable_cash_drop_and_closing_amount
                          )}
                          onChange={handleRegisterSettingInput}
                        />
                        <span className="qv_add_checkmark"></span>
                      </label>
                    </div>
                  </Grid>
                </Grid>
                {/* <div className="box"> */}
                {userTypeData.login_type === "superadmin" && (
                  <Grid sx={{ py: 2.5 }}>
                    <Grid container sx={{ px: { xs: 1, sm: 2.5 } }} spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <label className="text-[#6A6A6A] " htmlFor="idlelogout">
                          End of Day Allowance
                        </label>
                        <SelectDropDown
                          listItem={DayAllow}
                          title={"title"}
                          onClickHandler={handleOptionClick}
                          selectedOption={selectedDayAllow}
                          dropdownFor={"DayAllow"}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label className="text-[#6A6A6A] " htmlFor="idlelogout">
                          Shift Assignment
                        </label>
                        <SelectDropDown
                          listItem={SiftAssign}
                          title={"title"}
                          onClickHandler={handleOptionClick}
                          selectedOption={selectShiftAssign}
                          dropdownFor={"SiftAssign"}
                        />
                      </Grid>
                    </Grid>
                    {userTypeData?.login_type === "superadmin" &&
                      (selectShiftAssign === "Track Shifts by Cashier" ||
                        selectShiftAssign === "Track Shifts by Station") && (
                      <div className="col-qv-12 pb-5 sm:pb-0 mt-4 px-2 sm:px-5">
                        <button className="save_btn" onClick={openModal}>
                          End of Day
                        </button>
                      </div>
                    )}
                  </Grid>
                )}
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </Grid>

      {/* payment method */}

      <div className="q-resigtersetting-main-page">
        <div className="fixed-bottom">
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            sx={{
              mb: 0,
              px: { xs: 1, md: 2.5 },
              width: "100%",
              height: "auto",
              boxShadow: "0 5px 10px 1px var(--qv-shadow-dddddd, #ddd)",
              // margin: "30px 0px",
              borderRadius: "8px",
              backgroundColor: "var(--qv-bg-ffffff, #fff)",
              // padding: "0px",
              overflow: "hidden",
            }}
            // className="p-3"
          >
            <button
              className="store-setting-btn mt-5 mb-5 attributeUpdateBTN"
              onClick={handleRegisterSettingSubmit}
              disabled={loader}
            >
              {loader ? (
                <>
                  <CircularProgress color={"inherit"} width={15} size={15} />{" "}
                  Update
                </>
              ) : (
                "Update"
              )}
            </button>
          </Grid>
        </div>
      </div>

      {showModal && (
        <>
          <Modal
            open={showModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="view-category-item-modal qv-register-prefs" style={myStyles}>
              <div
                className="q-add-categories-section-header text-[18px]"
                style={{
                  justifyContent: "space-between",
                  fontFamily: "CircularSTDBook",
                }}
              >
                <span style={{ cursor: "unset" }}>Actual Amount</span>
                <div>
                  <img
                    src={CrossIcon}
                    alt="icon"
                    className="  quic-btn-cancle w-6 h-6 cursor-pointer"
                    onClick={() => closeModal()}
                  />
                </div>
              </div>

              <div className="view-category-item-modal-header">
                <div
                  className="title_attributes_section"
                  style={{ margin: "1rem 1rem" }}
                >
                  <label className="mb-2">Enter Actual Amount</label>
                  <BasicTextFields
                    type="text"
                    name="actual_amt"
                    onChangeFun={handleActualAmtInputChange}
                    value={actualAmount.actual_amt}
                    maxLength={9}
                    placeholder={"0.00"}
                    onKeyPressFun={handleKeyPress}
                    sx={{ pt: 0.5 }}
                  />
                  <span className="input-error">
                    {errorMessage !== "" ? errorMessage : ""}
                  </span>
                </div>
              </div>

              <div className="q-add-categories-section-middle-footer">
                <button
                  onClick={handleActualAmtSave}
                  className="quic-btn quic-btn-save attributeUpdateBTN"
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <CircularProgress
                        color={"inherit"}
                        className="loaderIcon"
                        width={15}
                        size={15}
                      />{" "}
                      Save{" "}
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
                <button
                  onClick={closeModal}
                  className="quic-btn quic-btn-cancle"
                >
                  Cancel
                </button>
              </div>
            </Box>
          </Modal>
        </>
      )}

      <AlertModal
        headerText={alertModalHeaderText}
        open={alertModalOpen}
        onClose={() => {
          setAlertModalOpen(false);
        }}
      />
    </>
  );
};

export default MainResigtersetting;
